import queryString from 'query-string'
import { CONSUMER_KEY, API_URL } from '../constants'
import { request, requestWithAuth } from './request'
import fetch from 'isomorphic-unfetch'

/**
 * create a new session guid
 */
export const createGuid = async () => {
  return request({
    path: '/guid'
  }).then(({ guid }) => guid)
}

/**
 * Get a user's information	server side
 */
export const getUserInfo = (cookie) => {
  const options = {
    hash: '9dJDjsla49la',
    consumer_key: CONSUMER_KEY,
    enable_cors: 1
  }
  const queryParams = queryString.stringify(options)
  const path = `${API_URL}/getuser?${queryParams}`

  return fetch(path, {
    method: 'GET',
    credentials: 'include',
    headers: { Cookie: cookie, Origin: 'https://getpocket.com' }
  })
    .then(handleErrors)
    .then(checkAuth)
    .then((response) => response.json())
}

/**
 * Get a user's information client side
 * NOTE: this is a workaround that will go away once auth is fixed
 */
export const getUserInfoDev = () => {
  return requestWithAuth({
    path: '/getuser',
    data: {
      hash: '9dJDjsla49la' // some sort of magic hash for this endpoint
    }
  })
}

/**
 * If the response was malformed/missing/etc.
 * @param {http response} response
 */
function handleErrors(response) {
  if (!response.ok) return Promise.reject(response)
  return response
}

/**
 * If the endpoint requires auth we want to reject the promise with
 * proper error codes.
 * @param {http response} response
 */
function checkAuth(response) {
  const xErrorCode = response.headers.get('x-error')
  if (xErrorCode) return Promise.reject(response)
  return response
}
